var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFlagMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.45 31.345l-9.274 1.949 6.278 7.012-5.489 4.021-4.883-8.106-4.883 8.106-5.592-4.02 6.188-6.816-9.278-2.146 2.094-6.433 8.583 3.676-.695-9.352h6.964l-1.094 9.191 8.888-3.621 2.193 6.54zM35.962 64V0H0v64l17.979-17.78L35.962 64z",
    fill: "#222F64"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzYiIGhlaWdodD0iNjQiIHZpZXdCb3g9IjAgMCAzNiA2NCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTMxLjQ0OTYgMzEuMzQ1MkwyMi4xNzYzIDMzLjI5MzZMMjguNDU0IDQwLjMwNjJMMjIuOTY1MSA0NC4zMjcxTDE4LjA4MTkgMzYuMjIwOUwxMy4xOTg3IDQ0LjMyNzFMNy42MDY1MSA0MC4zMDYyTDEzLjc5NSAzMy40OTEyTDQuNTE2OTUgMzEuMzQ1Mkw2LjYxMTA5IDI0LjkxMTZMMTUuMTk0MiAyOC41ODc5TDE0LjQ5OTMgMTkuMjM2M0gyMS40NjI2TDIwLjM2ODYgMjguNDI3MUwyOS4yNTY5IDI0LjgwNTlMMzEuNDQ5NiAzMS4zNDUyWk0zNS45NjE5IDY0VjBIMFY2NEwxNy45Nzg2IDQ2LjIyMDRMMzUuOTYxOSA2NFoiIGZpbGw9IiMyMjJGNjQiLz4KPC9zdmc+Cg==";
export { SvgFlagMobile as ReactComponent };